import { MdOutlineAppRegistration, MdFeaturedPlayList, MdContacts, MdDelete, MdInfo} from 'react-icons/md';
import { Button, Row, Container, Form, Table, Card, Accordion, Alert } from 'react-bootstrap';
import { useState, ChangeEvent } from 'react';
import ReactLoading from 'react-loading';
import { BodyStyles } from "./styles";
import { Agendamento } from "../CampoAgendamento/Agendamento";
import { SelectProduto } from "../CampoProduto/SelectProduto";
import { SelectEtiqueta } from "../CampoEtiqueta/SelectEtiqueta";
import { IItensListaChamado } from '../Interfaces/IItensListaChamado';
import { DataInicioAgendamento } from "../../constants/dataInicioAgendamento"
import { ses_id } from '../../constants/getSesId';
import adviceLogo from '../../assets/advice.png';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

export function Dashboard() {
    const [campoNome, setNome] = useState<string>("");
    const [emailPrincipal, setEmail] = useState<string>("");
    const [emailSecundario, setEmailSecundario] = useState<string>("");
    const [file, setFile] = useState<File>();
    const generateID = Math.round(Math.random() * 1000);
    const [produtoSelecionado, setProdutoSelecionado] = useState("");
    const [produtoIdSelecionado, setProdutoIdSelecionado] = useState<number>(0);
    const [etiquetaSelecionada, setEtiquetaSelecionada] = useState("");
    const [numeroEtiquetaSelecionada, setNumeroEtiquetaSelecionada] = useState<number>(0);
    const [campoDescricao, setDescricao] = useState("");
    const [campoDescricaoExibicao, setDescricaoExibicao] = useState("");
    const [dataAgendamento, setDataAgendamento] = useState<string>("");
    const [horaAgendamento, setHoraAgendamento] = useState<string>("");
    const [listaProdutosChamado, setListaProdutosChamados] = useState<IItensListaChamado[]>([]);
    const [pendenteDeAgendamento, setPendenteDeAgendamento] = useState(true);
    const [arquivoValido, setArquivoValido] = useState(true);
    const [removeLoading, setRemoveLoading] = useState<boolean>(true);
    const [retornoSucesso, setRetornoSucesso] = useState(false);
    const AlertTela = withReactContent(Swal);
    const URLPOST = process.env.REACT_APP_API_HOST || 'environment not defined'
    const WHATSAPP_FINANCEIRO_URL = 'https://wa.me/555130242111';

    const mensagemLimiteFranquia = (
        <span>
            <strong>Não foi possível abrir o chamado no momento.</strong>
            {' '}
            Sua franquia de horas foi concluída. Me chame{' '}
            <a href={WHATSAPP_FINANCEIRO_URL} target="_blank" rel="noopener noreferrer"><strong>aqui</strong></a>
            {' '}e selecione a &quot;Opção 3 - Financeiro&quot; para alinharmos o faturamento desta demanda extra.
        </span>
    );

    const decodeRetorno = (function() {
        // this prevents any overhead from creating the object each time
        var element = document.createElement('div');
      
        function decodeHTMLEntities (str: any) {
          if(str && typeof str === 'string') {
            // strip script/html tags
            str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
            str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
            element.innerHTML = str;
            str = element.textContent;
            element.textContent = '';
            str = str.split(":");
            str = str[str.length -1];
          }
      
          return str;
        }
      
        return decodeHTMLEntities;
    })();

    const addItemLista = (event: any): void => {
        event.preventDefault();
        const novoItemLista = { id: generateID, nomeDoProduto: produtoSelecionado, dadoProduto: produtoIdSelecionado, nomeEtiqueta: etiquetaSelecionada, dadoEtiqueta: numeroEtiquetaSelecionada, dadoDefeito: campoDescricao, DescricaoDefeito: campoDescricaoExibicao, dadoCondicoes: 3 }

        //Validações para adicionar na listagem
        const produtoNaoSelecionado = Object.values(novoItemLista).some(obj => obj === "" || obj === undefined);
        if (produtoNaoSelecionado) {
            AlertTela.fire({
                position: 'top',
                toast: true,
                timer: 2000,
                timerProgressBar: true,
                title: <i><strong>Preencha todos os dados do Produto!</strong></i>,
                html: <span>Os campos marcados com (*) são obrigatórios!</span>,
                icon: 'warning',
                showConfirmButton: false,
                background: '#bb2d3b',
                color: '#fff',
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                  }
              })
        }

        const limiteListaProdutos = listaProdutosChamado.length === 5 ;
        if (limiteListaProdutos) {
            AlertTela.fire({
                position: 'top',
                toast: true,
                timer: 4000,
                timerProgressBar: true,
                title: <i><strong>O limite de produtos já foi inserido na lista!</strong></i>,
                html: <span>Se for necessário cadastrar mais de 5 produtos, abra um novo chamado.</span>,
                icon: 'warning',
                showConfirmButton: false,
                background: '#bb2d3b',
                color: '#fff',
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                  }
              })
        }

        if (!produtoNaoSelecionado && !limiteListaProdutos) {
            setListaProdutosChamados([...listaProdutosChamado, novoItemLista]);
        }
        //Fim
    };

    const handleSetProduto = (event: any) => {
        if (event !== null) {
            setProdutoSelecionado(event.label);
            setProdutoIdSelecionado(event.value);
        } else {
            setProdutoIdSelecionado(0);
            setProdutoSelecionado("");
        }
    };

    const handleSetEtiqueta = (event: any) => {
        if (event !== null) {
            setEtiquetaSelecionada(event.label);
            setNumeroEtiquetaSelecionada(event.value);
        } else {
            setNumeroEtiquetaSelecionada(0);
            setEtiquetaSelecionada("");
        }
    };

    const addValorDescricao = (valor: any) => {
        setDescricao(ajustaCampoDescricao(valor));
        setDescricaoExibicao(valor);
    };

    const handleSetAgendamento= (event: any) => {
        if (event !== null) {
            setDataAgendamento(event.toLocaleDateString('en-GB'));
            setHoraAgendamento(event.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit",  hour12: false }));
        } else {
            setDataAgendamento("");
            setHoraAgendamento("");
        }
    }

    const [submitDataHora, setSubmitDataHora] = useState("");
    const [submitData, setSubmitData] = useState("");

    const registrarAgendamento = () => {
        if (dataAgendamento !== null && horaAgendamento !== null && horaAgendamento !== "" && dataAgendamento !== "") {
            setSubmitData(dataAgendamento);
            setSubmitDataHora(horaAgendamento);
            setPendenteDeAgendamento(false);
        }
        else {
            setSubmitData(DataInicioAgendamento().toLocaleDateString('en-GB'));
            setSubmitDataHora(DataInicioAgendamento().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false }));
            setPendenteDeAgendamento(false);
        }
    }

    const removerAgendamento = () => {
        setDataAgendamento("");
        setHoraAgendamento("");
        setSubmitData("");
        setSubmitDataHora("");
        setPendenteDeAgendamento(true);
    }

    const onDeleteLista = (ID: any) => {
        const listaOnDelete = listaProdutosChamado.filter((item) => item.id !== ID);
        setListaProdutosChamados(listaOnDelete);
    };

    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {

            const MAX_FILE_SIZE = 2048 // 2MB

            let arquivo = e.target.files[0];

            if(arquivo) {
                const fileSizeKiloBytes = arquivo.size / 1024
            
                const validExtensions = ['png','jpeg','jpg','pdf']
                const fileExtension = arquivo.type.split('/')[1]

                if (!validExtensions.includes(fileExtension)) {
                    AlertTela.fire({
                        position: 'top',
                        toast: true,
                        timer: 5000,
                        timerProgressBar: true,
                        title: <i><strong>O arquivo deve ser uma imagem ou um PDF!</strong></i>,
                        html: <span>O seu arquivo deve ser um PNG, JPEG, JPG ou PDF para ser enviado</span>,
                        icon: 'warning',
                        showConfirmButton: false,
                        background: '#bb2d3b',
                        color: '#fff',
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                          }
                      })
                    setArquivoValido(false);
                    setFile(undefined);
                    return
                }

                if(fileSizeKiloBytes > MAX_FILE_SIZE){
                    AlertTela.fire({
                        position: 'top',
                        toast: true,
                        timer: 5000,
                        timerProgressBar: true,
                        title: <i><strong>O tamanho do arquivo ultrapassou os 2MB permitidos!</strong></i>,
                        html: <span>O seu arquivo não pode ultrapassar 2MB para ser enviado.</span>,
                        icon: 'warning',
                        showConfirmButton: false,
                        background: '#bb2d3b',
                        color: '#fff',
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                          }
                      })
                    setArquivoValido(false);
                    setFile(undefined);
                    return
                }
                setArquivoValido(true);
            }
            setFile(arquivo);
        }
    };

    function ajustaCampoDescricao (texto: string) {
        let textos = "";

        for (var i = 0; i < texto.length; i++) {
            textos = textos + ajustaCaracteres(texto[i]);
        }

        return textos;
    }

    function ajustaCaracteres(texto: string) {

        let textos = texto;
    
        textos = textos.replace("!","%21");
        textos = textos.replace("#","%23");
        textos = textos.replace("$","%24");
        textos = textos.replace("%","%25");
        textos = textos.replace("&","%26");
        textos = textos.replace("'","%27");
        textos = textos.replace("(","%28");
        textos = textos.replace(")","%29");
        textos = textos.replace("*","%2A");
        textos = textos.replace("+","%2B");
        textos = textos.replace(",","%2C");
        textos = textos.replace("-","-");
        textos = textos.replace(".",".");
        textos = textos.replace("/","%2F");
        textos = textos.replace("0","0");
        textos = textos.replace("1","1");
        textos = textos.replace("2","2");
        textos = textos.replace("3","3");
        textos = textos.replace("4","4");
        textos = textos.replace("5","5");
        textos = textos.replace("6","6");
        textos = textos.replace("7","7");
        textos = textos.replace("8","8");
        textos = textos.replace("9","9");
        textos = textos.replace(":","%3A");
        textos = textos.replace(";","%3B");
        textos = textos.replace("<","%3C");
        textos = textos.replace("=","%3D");
        textos = textos.replace(">","%3E");
        textos = textos.replace("?","%3F");
        textos = textos.replace("@","%40");
        textos = textos.replace("A","A");
        textos = textos.replace("B","B");
        textos = textos.replace("C","C");
        textos = textos.replace("D","D");
        textos = textos.replace("E","E");
        textos = textos.replace("F","F");
        textos = textos.replace("G","G");
        textos = textos.replace("H","H");
        textos = textos.replace("I","I");
        textos = textos.replace("J","J");
        textos = textos.replace("K","K");
        textos = textos.replace("L","L");
        textos = textos.replace("M","M");
        textos = textos.replace("N","N");
        textos = textos.replace("O","O");
        textos = textos.replace("P","P");
        textos = textos.replace("Q","Q");
        textos = textos.replace("R","R");
        textos = textos.replace("S","S");
        textos = textos.replace("T","T");
        textos = textos.replace("U","U");
        textos = textos.replace("V","V");
        textos = textos.replace("W","W");
        textos = textos.replace("X","X");
        textos = textos.replace("Y","Y");
        textos = textos.replace("Z","Z");
        textos = textos.replace("[","%5B");
        textos = textos.replace("\\","%5C");
        textos = textos.replace("]","%5D");
        textos = textos.replace("^","%5E");
        textos = textos.replace("_","_");
        textos = textos.replace("`","%60");
        textos = textos.replace("a","a");
        textos = textos.replace("b","b");
        textos = textos.replace("c","c");
        textos = textos.replace("d","d");
        textos = textos.replace("e","e");
        textos = textos.replace("f","f");
        textos = textos.replace("g","g");
        textos = textos.replace("h","h");
        textos = textos.replace("i","i");
        textos = textos.replace("j","j");
        textos = textos.replace("k","k");
        textos = textos.replace("l","l");
        textos = textos.replace("m","m");
        textos = textos.replace("n","n");
        textos = textos.replace("o","o");
        textos = textos.replace("p","p");
        textos = textos.replace("q","q");
        textos = textos.replace("r","r");
        textos = textos.replace("s","s");
        textos = textos.replace("t","t");
        textos = textos.replace("u","u");
        textos = textos.replace("v","v");
        textos = textos.replace("w","w");
        textos = textos.replace("x","x");
        textos = textos.replace("y","y");
        textos = textos.replace("z","z");
        textos = textos.replace("{","%7B");
        textos = textos.replace("|","%7C");
        textos = textos.replace("}","%7D");
        textos = textos.replace("~","%7E");
        textos = textos.replace("€","0,8");
        textos = textos.replace("‚","0,82");
        textos = textos.replace("ƒ","0,83");
        textos = textos.replace("„","0,84");
        textos = textos.replace("…","0,85");
        textos = textos.replace("†","0,86");
        textos = textos.replace("‡","0,87");
        textos = textos.replace("ˆ","0,88");
        textos = textos.replace("‰","0,89");
        textos = textos.replace("Š","%8A");
        textos = textos.replace("‹","%8B");
        textos = textos.replace("Œ","%8C");
        textos = textos.replace("","%8D");
        textos = textos.replace("Ž","%8E");
        textos = textos.replace("‘","0,91");
        textos = textos.replace("’","0,92");
        textos = textos.replace("“","0,93");
        textos = textos.replace("”","0,94");
        textos = textos.replace("•","0,95");
        textos = textos.replace("–","0,96");
        textos = textos.replace("—","0,97");
        textos = textos.replace("˜","0,98");
        textos = textos.replace("™","0,99");
        textos = textos.replace("š","%9A");
        textos = textos.replace("›","%9B");
        textos = textos.replace("œ","%9C");
        textos = textos.replace("","%9D");
        textos = textos.replace("ž","%9E");
        textos = textos.replace("Ÿ","%9F");
        textos = textos.replace("¡","%A1");
        textos = textos.replace("¢","%A2");
        textos = textos.replace("£","%A3");
        textos = textos.replace("¤","%A4");
        textos = textos.replace("¥","%A5");
        textos = textos.replace("¦","%A6");
        textos = textos.replace("§","%A7");
        textos = textos.replace("¨","%A8");
        textos = textos.replace("©","%A9");
        textos = textos.replace("ª","%AA");
        textos = textos.replace("«","%AB");
        textos = textos.replace("¬","%AC");
        textos = textos.replace("­","%AD");
        textos = textos.replace("®","%AE");
        textos = textos.replace("¯","%AF");
        textos = textos.replace("°","%B0");
        textos = textos.replace("±","%B1");
        textos = textos.replace("²","%B2");
        textos = textos.replace("³","%B3");
        textos = textos.replace("´","%B4");
        textos = textos.replace("µ","%B5");
        textos = textos.replace("¶","%B6");
        textos = textos.replace("·","%B7");
        textos = textos.replace("¸","%B8");
        textos = textos.replace("¹","%B9");
        textos = textos.replace("º","%BA");
        textos = textos.replace("»","%BB");
        textos = textos.replace("¼","%BC");
        textos = textos.replace("½","%BD");
        textos = textos.replace("¾","%BE");
        textos = textos.replace("¿","%BF");
        textos = textos.replace("À","%C0");
        textos = textos.replace("Á","%C1");
        textos = textos.replace("Â","%C2");
        textos = textos.replace("Ã","%C3");
        textos = textos.replace("Ä","%C4");
        textos = textos.replace("Å","%C5");
        textos = textos.replace("Æ","%C6");
        textos = textos.replace("Ç","%C7");
        textos = textos.replace("È","%C8");
        textos = textos.replace("É","%C9");
        textos = textos.replace("Ê","%CA");
        textos = textos.replace("Ë","%CB");
        textos = textos.replace("Ì","%CC");
        textos = textos.replace("Í","%CD");
        textos = textos.replace("Î","%CE");
        textos = textos.replace("Ï","%CF");
        textos = textos.replace("Ð","%D0");
        textos = textos.replace("Ñ","%D1");
        textos = textos.replace("Ò","%D2");
        textos = textos.replace("Ó","%D3");
        textos = textos.replace("Ô","%D4");
        textos = textos.replace("Õ","%D5");
        textos = textos.replace("Ö","%D6");
        textos = textos.replace("×","%D7");
        textos = textos.replace("Ø","%D8");
        textos = textos.replace("Ù","%D9");
        textos = textos.replace("Ú","%DA");
        textos = textos.replace("Û","%DB");
        textos = textos.replace("Ü","%DC");
        textos = textos.replace("Ý","%DD");
        textos = textos.replace("Þ","%DE");
        textos = textos.replace("ß","%DF");
        textos = textos.replace("à","%E0");
        textos = textos.replace("á","%E1");
        textos = textos.replace("â","%E2");
        textos = textos.replace("ã","%E3");
        textos = textos.replace("ä","%E4");
        textos = textos.replace("å","%E5");
        textos = textos.replace("æ","%E6");
        textos = textos.replace("ç","%E7");
        textos = textos.replace("è","%E8");
        textos = textos.replace("é","%E9");
        textos = textos.replace("ê","%EA");
        textos = textos.replace("ë","%EB");
        textos = textos.replace("ì","%EC");
        textos = textos.replace("í","%ED");
        textos = textos.replace("î","%EE");
        textos = textos.replace("ï","%EF");
        textos = textos.replace("ð","%F0");
        textos = textos.replace("ñ","%F1");
        textos = textos.replace("ò","%F2");
        textos = textos.replace("ó","%F3");
        textos = textos.replace("ô","%F4");
        textos = textos.replace("õ","%F5");
        textos = textos.replace("ö","%F6");
        textos = textos.replace("÷","%F7");
        textos = textos.replace("ø","%F8");
        textos = textos.replace("ù","%F9");
        textos = textos.replace("ú","%FA");
        textos = textos.replace("û","%FB");
        textos = textos.replace("ü","%FC");
        textos = textos.replace("ý","%FD");
        textos = textos.replace("þ","%FE");
        textos = textos.replace("ÿ","%FF");
    
        return textos;
    };

    const Submeter = (event: any) => {
        event.preventDefault();

        let form = new FormData();

        //Preenche o chamado conforme o E-mail
        if(emailSecundario !== "") {
            const chamados = { solicitante: ajustaCampoDescricao(campoNome), email: [emailPrincipal, emailSecundario], listaProduto: listaProdutosChamado, endereco_atendimento: '', enderecooutro: '', dadoQtd: 1, hrAgendamento: submitDataHora, dtAgendamento: submitData }
            form.append('dados', JSON.stringify(chamados)); 
        }
        else{
            const chamados = { solicitante: ajustaCampoDescricao(campoNome), email: emailPrincipal, listaProduto: listaProdutosChamado, endereco_atendimento: '', enderecooutro: '', dadoQtd: 1, hrAgendamento: submitDataHora, dtAgendamento: submitData }
            form.append('dados', JSON.stringify(chamados)); 
        }
        //Fim

        const sessao = {ses_id: ses_id};

        form.append('sessao', JSON.stringify(sessao));

        if (file) {
            form.append('arquivo', file);
        }   

        //Verifica se a lista não está vazia/Agendamento válido
        const limiteListaProdutos = listaProdutosChamado.length < 1 ;
        if (limiteListaProdutos) {
            AlertTela.fire({
                position: 'top',
                toast: true,
                timer: 3000,
                timerProgressBar: true,
                title: <i><strong>Nenhum produto cadastrado!</strong></i>,
                html: <span>Você deve cadastrar ao menos 1 produto na lista.</span>,
                icon: 'warning',
                showConfirmButton: false,
                background: '#bb2d3b',
                color: '#fff',
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                  }
              })
        } else if (submitData === (DataInicioAgendamento().toLocaleDateString('en-GB')) && submitDataHora !== "" && (submitDataHora < (DataInicioAgendamento().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false })) || submitDataHora > "17:00")) {
            AlertTela.fire({
                position: 'top',
                toast: true,
                timer: 5000,
                timerProgressBar: true,
                title: <i><strong>Agendamento Inválido!</strong></i>,
                html: <span>Você não pode agendar um horário anterior aos horários disponibilizados. Escolha um horário válido na seleção de agendamento.</span>,
                icon: 'warning',
                showConfirmButton: false,
                background: '#bb2d3b',
                color: '#fff',
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                  }
              })
        } else if (submitData > (DataInicioAgendamento().toLocaleDateString('en-GB')) && submitDataHora !== "" && (submitDataHora < "08:30"  || submitDataHora > "17:00")) {
            AlertTela.fire({
                position: 'top',
                toast: true,
                timer: 5000,
                timerProgressBar: true,
                title: <i><strong>Agendamento Inválido!</strong></i>,
                html: <span>Você não pode agendar um horário fora do horário de atendimento. Escolha um horário válido na seleção de agendamento.</span>,
                icon: 'warning',
                showConfirmButton: false,
                background: '#bb2d3b',
                color: '#fff',
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                  }
              })
        } else {
            setRemoveLoading(false);
            const request = {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, application/xml, text/plain, text/html, .',
                    'Content-Type': 'multipart/form-data',
                },
                body: form
            };

            setTimeout(() => {
                fetch(URLPOST+'cliente/controller/controllerChamado.asp', request)
                .then((result) => result.json())
                .then((data) => {
                    setRemoveLoading(true);
                    if(data.retorno === "") {
                        AlertTela.fire({
                            timerProgressBar: true,
                            title: <i><strong>Chamado aberto com Sucesso!</strong></i>,
                            html: <span>Em breve entraremos em contato para lhe apoiar neste chamado.</span>,
                            icon: 'success',
                            showConfirmButton: true,
                            confirmButtonColor: '#65cea7',
                            allowOutsideClick: false,
                          }).then((result) => {
                            if (result.isConfirmed) {
                                window.location.href = URLPOST+'cliente/fechar.asp';
                            }
                          });
                        setRetornoSucesso(true);
                    }
                    else if (data.retorno === 'LIMITE_MENSAL_CHAMADOS') {
                        AlertTela.fire({
                            title: <i><strong>Franquia concluída</strong></i>,
                            html: mensagemLimiteFranquia,
                            icon: 'info',
                            showConfirmButton: true,
                            confirmButtonColor: '#65cea7',
                            allowOutsideClick: false,
                        });
                    }
                    else {
                        AlertTela.fire({
                            position: 'top',
                            toast: true,
                            timer: 5000,
                            timerProgressBar: true,
                            title: <i><strong>Erro ao enviar chamado!</strong></i>,
                            html: <span>{decodeRetorno(data.retorno)}</span>,
                            icon: 'warning',
                            showConfirmButton: false,
                            background: '#bb2d3b',
                            color: '#fff',
                            didOpen: (toast) => {
                                toast.addEventListener('mouseenter', Swal.stopTimer)
                                toast.addEventListener('mouseleave', Swal.resumeTimer)
                              }
                          })
                    }   
                });
            },1000)
        }
    }

    return (
        <BodyStyles>
            <div className="Dashboard">
                <Container>
                    <Form onSubmit={Submeter}>
                        <Row className="col-md-12">
                            <Form.Group className="col-12 col-md-12 col-sm-12">
                                <Form.Group className="float-end mb-2" style={{ paddingLeft: 10}}>
                                {retornoSucesso ? 
                                    ""
                                : 
                                    <Button type="submit" className="btn btn-adviceSuccess">
                                        Finalizar
                                    </Button>   
                                }
                                </Form.Group>
                                <Form.Group className="float-end">
                                    <Button className="btn btn-danger" onClick={() => window.location.href = URLPOST+'/Cliente/fechar.asp'}>
                                        Fechar
                                    </Button>  
                                </Form.Group>
                            </Form.Group>
                            <Card border="light" className="col-12 col-md-12 col-sm-12" style={{ paddingLeft: 0, paddingRight: 0 }}>
                                <Card.Header><Card.Title><MdContacts/> Informações</Card.Title></Card.Header>
                                <Card.Body>
                                    <Row className="col-md-12">
                                        <Form.Group className="col-md-6 mb-2">
                                            <Form.Label>Nome do solicitante <span>*</span></Form.Label>
                                            <Form.Control name="Nome do solicitante" placeholder="Digite o nome do solicitante" value={campoNome} onChange={event => setNome(event.target.value)} required/>
                                        </Form.Group>
                                        <Form.Group className="col-md-6">
                                            <Form.Label>E-mail <span>*</span></Form.Label>
                                            <Form.Group className="input-group">
                                                <Form.Control className='col-6' type="Email" name="E-mail" placeholder="Digite o seu E-mail" value={emailPrincipal} onChange={event => setEmail(event.target.value)} required/>
                                                <Form.Control className='col-6' type="Email" name="E-mailSecundario" placeholder="E-mail secundário (Opcional)" value={emailSecundario} onChange={event => setEmailSecundario(event.target.value)}/>
                                            </Form.Group>
                                        </Form.Group>
                                    </Row>
                                    <Row className="col-md-12 mt-2">
                                        <Form.Group controlId="formFile">
                                            <Form.Label>Envie-nos um print do problema <span>(Max: 2MB)</span></Form.Label>
                                            {!arquivoValido ? 
                                                <Form.Control className="text-danger" onChange={handleFileChange} type="file"/>
                                            : 
                                                <Form.Control onChange={handleFileChange} type="file"/>
                                            }
                                        </Form.Group>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Row>
                        <Row className="col-md-12">
                            <Card border="light" className="col-md-12 mt-2" style={{ paddingLeft: 0, paddingRight: 0 }}>
                                <Card.Header><Card.Title><MdOutlineAppRegistration/> Cadastrar produto para manutenção</Card.Title></Card.Header>
                                <Card.Body>
                                    <Row className="col-md-12">
                                        <Form.Group className="col-md-6">
                                            <Form.Group>
                                                <Form.Label>Produto <span>*</span></Form.Label>
                                                <SelectProduto onChange={(event: any) => handleSetProduto(event)}/>
                                            </Form.Group>
                                            <Form.Group className="mt-2 mb-2">
                                                <Form.Label>Etiqueta <span>*</span></Form.Label>
                                                <SelectEtiqueta onChange={(event: any) => handleSetEtiqueta(event)}/>
                                            </Form.Group>
                                        </Form.Group>
                                        <Form.Group controlId="descricaoId" className="col-md-6">
                                            <Form.Label>Descrição do defeito <span>*</span></Form.Label>
                                            <Form.Control as="textarea" rows={5} value={campoDescricaoExibicao} onChange={event => addValorDescricao(event.target.value)}/>
                                                <Button className="float-end btn btn-adviceSuccess mt-2" onClick={addItemLista}>
                                                    Adicionar Item
                                                </Button>
                                        </Form.Group>             
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Row>
                        <Row className="col-md-12">
                            <Card border="light" className="col-md-8 col-sm-12 col-12 mt-2 listaDefeito" style={{ paddingLeft: 0, paddingRight: 0 }}>
                                <Card.Header><Card.Title><MdFeaturedPlayList/> Lista de produtos com defeito</Card.Title></Card.Header>
                                <Card.Body className="col-md-12" style={{ padding: 0 }}>
                                    <Table>
                                        <thead className="bg-table">
                                            <tr>
                                                <th className="col-md-3 col-3">Produto</th>
                                                <th className="col-md-2 col-2">Etiqueta</th>
                                                <th className="col-md-6 col-6">Descrição do defeito</th>
                                                <th className="col-md-1 col-1"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {listaProdutosChamado.map((produto) => (
                                                <tr key={produto.id}>
                                                    <td>{produto.nomeDoProduto}</td> 
                                                    <td>{produto.nomeEtiqueta}</td> 
                                                    <td>{produto.DescricaoDefeito}</td>
                                                    <td onClick={() => onDeleteLista(produto.id)}><MdDelete/></td> 
                                                </tr>   
                                            ))}                                                        
                                        </tbody>
                                    </Table> 
                                </Card.Body>
                            </Card> 
                            <Row className="col-12 col-sm-12 col-md-4 mt-2 centralizar">
                                <Accordion className="col-md-12">
                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header onClick={removerAgendamento}>Adicionar agendamento</Accordion.Header>
                                        <Accordion.Body>
                                                <Form.Group className="col-md-12 col-12 col-sm-12 mb-2 centralizar">
                                                    {pendenteDeAgendamento  ? 
                                                        <Alert className="col-12 centralizar" variant="warning">
                                                            <MdInfo/> Caso queira fazer um agendamento, selecione uma data e horário validos abaixo.
                                                        </Alert> 
                                                    :   
                                                        <Alert className="col-12 centralizar" variant="success">
                                                            <MdInfo/> Agendado com sucesso para {submitData} às {submitDataHora}
                                                        </Alert> 
                                                    }
                                                    {pendenteDeAgendamento ? 
                                                        <Agendamento onChange={(event: any) => handleSetAgendamento(event)}/>
                                                    :
                                                        ""
                                                    }  
                                                    {!pendenteDeAgendamento ?
                                                        <Button className="col-12 mt-2 centralizar btn btn-danger" onClick={removerAgendamento}>Remover</Button>
                                                    :  
                                                        <Button className="col-12 mt-2 centralizar btn btn-adviceSuccess" onClick={registrarAgendamento}>Agendar</Button>
                                                    }
                                                </Form.Group>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>  
                            </Row>
                        </Row> 
                    </Form>
                </Container>
            </div>
            {!removeLoading && <div className="loading-overlay centralize"><img className="float-start col-3 col-md-1 col-sm-3 mb-4" src={adviceLogo} alt="Advice" />O chamado está sendo registrado...<ReactLoading className="centralize" type={"bubbles" } color={"#ffca03"} height={'5%'} width={'5%'} /></div> }
        </BodyStyles>
    );
  }